import React from 'react';

export const VideoAdPreview = ({ ad }) => (
  <video controls>
    <source src={ad.video.src} />
    <track
      kind="captions"
      src=""
      srcLang="en"
      label="English"
      default
    />
  </video>
);
